import { SpeechRate } from "../api";

export interface Settings {
    speechRate: SpeechRate;
}

export type Action = { type: "speechRate"; value: SpeechRate };

export const initialState: Settings = {
    speechRate: SpeechRate.Medium
};

export const reducer = (state: Settings, action: Action): Settings => {
    switch (action.type) {
        case "speechRate":
            return { ...state, speechRate: action.value };

        default:
            return state; // Return current state for unknown actions
    }
};
